import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/UserAuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 size={48} className="animate-spin text-purple-500" />
      </div>
    );
  }

  // Redirect to auth if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Admin users bypass subscription requirement
  // Check both boolean true and string 'true' for robustness
  const isAdmin = user?.is_admin === true || user?.is_admin === 'true';
  
  // Pages that bypass subscription check:
  // - /pricing (to select a plan)
  // - /admin (has its own ADMIN_KEY password protection)
  const bypassSubscriptionCheck = location.pathname === '/pricing' || location.pathname === '/admin';
  
  // Redirect to pricing if no active subscription (except for bypass pages and admin users)
  const subscriptionStatus = user?.subscription_status;
  if (!isAdmin && !bypassSubscriptionCheck && (!subscriptionStatus || subscriptionStatus === 'none')) {
    return <Navigate to="/pricing" replace />;
  }

  // Redirect to onboarding if not completed (except for onboarding page itself and admin page)
  // Admin users still need to complete onboarding for profile setup
  if (!user?.onboarding_completed && location.pathname !== '/onboarding' && location.pathname !== '/admin') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;
